import { atom, useAtom, useSetAtom } from "jotai";

export const LiveSearch = atom("");

const useLiveSearch = () => {
  return useAtom(LiveSearch);
};

export const useSetLiveSearch = () => useSetAtom(LiveSearch);

export default useLiveSearch;
